import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";

const Logo = ({ width }) => {
	const theme = useTheme();
	return (
		<svg
			version="1.1"
			id="Layer_1"
			xmlns="http://www.w3.org/2000/svg"
			x="0px"
			y="0px"
			width={width || "100%"}
			viewBox="0 0 429 445"
			enableBackground="new 0 0 429 445"
			xmlSpace="preserve"
		>
			{/* <path
                fill="#FFFFFF"
                opacity="1.000000"
                stroke="none"
                d="
M378.000000,446.000000 
	C270.311890,446.000000 162.623810,446.000000 54.467857,445.564453 
	C54.016899,443.796173 53.814304,442.417114 54.084213,441.137726 
	C57.223843,426.256012 62.160923,412.092834 69.958214,398.902191 
	C84.546501,374.223297 104.566856,354.963654 129.989182,342.337524 
	C147.949249,333.417542 167.338715,327.377228 186.079834,320.025299 
	C187.721115,319.381439 189.286331,318.543671 191.840881,317.350311 
	C180.585312,313.274109 170.639542,309.349060 160.487137,306.062469 
	C138.986984,299.102264 119.086403,288.974731 102.050110,274.245392 
	C84.653358,259.204376 70.062996,241.679688 61.752014,219.669434 
	C61.143009,218.056610 58.386417,216.021133 56.848480,216.189804 
	C45.605381,217.422958 40.022038,210.427841 36.489498,201.749329 
	C29.055048,183.484909 28.767218,164.717667 35.088905,146.029007 
	C39.708183,132.373123 43.963959,129.449371 58.190094,128.977890 
	C58.682236,128.961594 59.170700,128.834229 59.499825,128.783463 
	C62.762867,122.265778 65.738075,115.732185 69.216476,109.478477 
	C83.509987,83.780571 104.494125,64.894661 130.107086,51.048645 
	C149.036560,40.815636 169.331406,34.797165 190.714340,31.788719 
	C206.401489,29.581633 222.024780,29.310007 237.583405,31.200361 
	C253.402924,33.122417 268.893921,36.972950 283.761780,43.005394 
	C302.248779,50.506264 319.094116,60.614769 333.716675,74.244942 
	C349.010834,88.501167 361.454071,104.805130 369.123108,124.456779 
	C370.425415,127.793907 372.365204,129.776184 376.447510,129.066223 
	C381.667938,128.158340 386.490692,129.325104 389.490112,134.100952 
	C391.908295,137.951416 394.354248,141.926682 395.874939,146.173477 
	C401.819397,162.774155 401.959991,179.784088 396.601196,196.392639 
	C393.082977,207.296829 387.998779,217.926743 373.066467,216.147171 
	C372.156799,216.038742 370.545990,217.787918 370.029510,219.000015 
	C359.804260,242.998962 343.908234,262.682953 323.562256,278.649719 
	C306.249176,292.236359 286.350250,301.117523 265.532867,308.029907 
	C257.006836,310.860931 248.600235,314.051483 238.819794,317.550568 
	C242.745483,319.068146 245.274445,320.073608 247.823105,321.026398 
	C262.572144,326.540405 277.578827,331.456177 292.016022,337.691132 
	C311.506470,346.108337 328.283173,358.650696 342.776428,374.238373 
	C355.282867,387.689270 365.133026,402.781555 370.980530,420.223663 
	C373.806396,428.652802 375.689850,437.397949 378.000000,446.000000 
M292.442993,214.000565 
	C309.310272,211.085526 326.177582,208.170471 342.805817,205.296738 
	C342.805817,182.272964 342.805817,160.318497 342.805817,138.456650 
	C257.798248,119.244354 173.004837,119.249336 88.139969,138.471848 
	C88.139969,160.581223 88.139969,182.538651 88.139969,204.843445 
	C88.989937,204.904999 89.782654,204.893417 90.549721,205.028030 
	C111.331528,208.674744 132.047958,212.762283 152.913727,215.836899 
	C165.557434,217.699966 178.421570,218.646286 191.204681,218.844864 
	C209.281555,219.125702 227.394394,218.740677 245.455521,217.878815 
	C260.840851,217.144623 276.174835,215.334702 292.442993,214.000565 
z"
            /> */}
			<path
				fill="white"
				opacity="1.000000"
				stroke="none"
				d="
M378.468658,446.000000 
	C375.689850,437.397949 373.806396,428.652802 370.980530,420.223663 
	C365.133026,402.781555 355.282867,387.689270 342.776428,374.238373 
	C328.283173,358.650696 311.506470,346.108337 292.016022,337.691132 
	C277.578827,331.456177 262.572144,326.540405 247.823105,321.026398 
	C245.274445,320.073608 242.745483,319.068146 238.819794,317.550568 
	C248.600235,314.051483 257.006836,310.860931 265.532867,308.029907 
	C286.350250,301.117523 306.249176,292.236359 323.562256,278.649719 
	C343.908234,262.682953 359.804260,242.998962 370.029510,219.000015 
	C370.545990,217.787918 372.156799,216.038742 373.066467,216.147171 
	C387.998779,217.926743 393.082977,207.296829 396.601196,196.392639 
	C401.959991,179.784088 401.819397,162.774155 395.874939,146.173477 
	C394.354248,141.926682 391.908295,137.951416 389.490112,134.100952 
	C386.490692,129.325104 381.667938,128.158340 376.447510,129.066223 
	C372.365204,129.776184 370.425415,127.793907 369.123108,124.456779 
	C361.454071,104.805130 349.010834,88.501167 333.716675,74.244942 
	C319.094116,60.614769 302.248779,50.506264 283.761780,43.005394 
	C268.893921,36.972950 253.402924,33.122417 237.583405,31.200361 
	C222.024780,29.310007 206.401489,29.581633 190.714340,31.788719 
	C169.331406,34.797165 149.036560,40.815636 130.107086,51.048645 
	C104.494125,64.894661 83.509987,83.780571 69.216476,109.478477 
	C65.738075,115.732185 62.762867,122.265778 59.499825,128.783463 
	C59.170700,128.834229 58.682236,128.961594 58.190094,128.977890 
	C43.963959,129.449371 39.708183,132.373123 35.088905,146.029007 
	C28.767218,164.717667 29.055048,183.484909 36.489498,201.749329 
	C40.022038,210.427841 45.605381,217.422958 56.848480,216.189804 
	C58.386417,216.021133 61.143009,218.056610 61.752014,219.669434 
	C70.062996,241.679688 84.653358,259.204376 102.050110,274.245392 
	C119.086403,288.974731 138.986984,299.102264 160.487137,306.062469 
	C170.639542,309.349060 180.585312,313.274109 191.840881,317.350311 
	C189.286331,318.543671 187.721115,319.381439 186.079834,320.025299 
	C167.338715,327.377228 147.949249,333.417542 129.989182,342.337524 
	C104.566856,354.963654 84.546501,374.223297 69.958214,398.902191 
	C62.160923,412.092834 57.223843,426.256012 54.084213,441.137726 
	C53.814304,442.417114 54.016899,443.796173 54.000000,445.564453 
	C44.312439,446.000000 34.624874,446.000000 24.468658,445.562134 
	C27.005871,432.519775 29.068316,419.593048 33.237038,407.385620 
	C39.611061,388.720337 49.996647,372.025055 63.244873,357.377411 
	C77.575844,341.532684 93.690926,327.727448 112.408882,317.794769 
	C105.385307,313.106201 98.206589,308.882324 91.661797,303.836273 
	C73.564789,289.883331 57.590195,273.855103 46.052170,253.909271 
	C42.557938,247.868774 38.910374,242.522034 31.803560,240.183868 
	C29.155872,239.312790 26.848274,237.070160 24.685177,235.120560 
	C13.321587,224.878525 7.333003,211.642014 4.043258,197.029556 
	C2.777996,191.409515 2.000008,185.679764 1.000000,180.000000 
	C1.000000,175.310745 1.000000,170.621490 1.381436,165.273102 
	C1.948995,154.047714 3.979343,143.833832 8.068537,134.103302 
	C13.267599,121.731720 19.795601,110.087097 32.500706,104.100266 
	C38.820728,101.122169 42.463444,96.595581 45.708828,90.847557 
	C56.299328,72.090279 70.617790,56.227695 87.668861,43.460167 
	C100.489525,33.860287 114.778496,25.984741 129.101639,18.692554 
	C144.352936,10.927829 160.968094,6.637728 177.928513,3.976661 
	C183.634232,3.081441 189.310349,1.997620 195.000000,1.000000 
	C208.354233,1.000000 221.708450,1.000000 235.721329,1.379531 
	C250.439285,4.460688 264.774109,6.189016 278.498444,10.073954 
	C304.179871,17.343580 327.377502,29.683058 347.812592,47.175171 
	C364.605347,61.549519 378.793427,77.883858 389.222595,97.442322 
	C390.089203,99.067513 392.086395,100.181099 393.724121,101.286720 
	C398.576996,104.562866 404.174988,107.037979 408.285187,111.051529 
	C418.336090,120.866043 423.964447,133.328171 426.959961,146.950394 
	C428.198792,152.584015 428.999847,158.313904 430.000000,164.000000 
	C430.000000,169.354935 430.000000,174.709854 429.620789,180.721878 
	C427.474030,190.307861 426.602203,199.535934 423.741821,208.099823 
	C418.670593,223.283066 409.767670,235.809921 394.586212,242.832703 
	C392.821045,243.649261 390.886902,244.928558 389.926910,246.530243 
	C379.866516,263.315613 368.752991,279.294952 353.534149,291.843292 
	C342.352264,301.063019 330.649689,309.651215 319.626923,318.174591 
	C335.333282,327.662018 351.123138,339.251495 364.679504,353.968658 
	C378.030823,368.463226 388.512482,384.595459 396.194702,402.627228 
	C402.102448,416.493958 405.825562,430.937775 407.000000,446.000000 
	C397.645782,446.000000 388.291534,446.000000 378.468658,446.000000 
z"
			/>
			<path
				fill={theme.palette.secondary.main}
				opacity="1.000000"
				stroke="none"
				d="
M291.987244,214.000610 
	C276.174835,215.334702 260.840851,217.144623 245.455521,217.878815 
	C227.394394,218.740677 209.281555,219.125702 191.204681,218.844864 
	C178.421570,218.646286 165.557434,217.699966 152.913727,215.836899 
	C132.047958,212.762283 111.331528,208.674744 90.549721,205.028030 
	C89.782654,204.893417 88.989937,204.904999 88.139969,204.843445 
	C88.139969,182.538651 88.139969,160.581223 88.139969,138.471848 
	C173.004837,119.249336 257.798248,119.244354 342.805817,138.456650 
	C342.805817,160.318497 342.805817,182.272964 342.805817,205.296738 
	C326.177582,208.170471 309.310272,211.085526 291.987244,214.000610 
M171.015442,187.999435 
	C172.179245,188.039215 173.343781,188.128067 174.506760,188.111069 
	C184.117340,187.970551 191.463379,179.984238 190.738617,170.485611 
	C190.013351,160.980286 181.553650,153.929199 172.233398,155.061661 
	C164.651566,155.982895 158.546799,162.022446 157.770706,169.369858 
	C156.824463,178.328018 160.897354,184.394302 171.015442,187.999435 
M266.380524,157.936691 
	C256.922546,152.714188 246.874069,155.096054 242.250427,163.656433 
	C237.843063,171.816422 240.984589,182.029678 249.235779,186.366119 
	C256.541718,190.205795 265.834320,187.948639 270.543213,181.190613 
	C275.503754,174.071442 274.115326,165.161179 266.380524,157.936691 
z"
			/>
			<path
				fill="white"
				opacity="1.000000"
				stroke="none"
				d="
M170.600555,187.930267 
	C160.897354,184.394302 156.824463,178.328018 157.770706,169.369858 
	C158.546799,162.022446 164.651566,155.982895 172.233398,155.061661 
	C181.553650,153.929199 190.013351,160.980286 190.738617,170.485611 
	C191.463379,179.984238 184.117340,187.970551 174.506760,188.111069 
	C173.343781,188.128067 172.179245,188.039215 170.600555,187.930267 
z"
			/>
			<path
				fill="white"
				opacity="1.000000"
				stroke="none"
				d="
M266.683655,158.151871 
	C274.115326,165.161179 275.503754,174.071442 270.543213,181.190613 
	C265.834320,187.948639 256.541718,190.205795 249.235779,186.366119 
	C240.984589,182.029678 237.843063,171.816422 242.250427,163.656433 
	C246.874069,155.096054 256.922546,152.714188 266.683655,158.151871 
z"
			/>
		</svg>
	);
};
Logo.propTypes = {
	width: PropTypes.string,
};
export default Logo;
